import React from 'react'
import { Routes, Route, Navigate, Link } from 'react-router-dom'
import { FileText } from 'lucide-react'
import { Card, CardContent } from '../ui/card'
import { Button } from '../ui/button'
import { reports, useReportGates } from './reportRegistry'
import { ReportHub } from './ReportHub'
import { ReportPageLayout } from './ReportPageLayout'

const ReportAccessDenied: React.FC = () => (
  <div className="container mx-auto px-4 py-6">
    <Card>
      <CardContent className="py-12 text-center">
        <FileText className="mx-auto h-10 w-10 text-muted-foreground mb-3" />
        <p className="text-sm font-medium">You don&apos;t have access to this report</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Contact an administrator if you need access.
        </p>
        <Button variant="outline" className="mt-4" asChild>
          <Link to="/report">Back to Reports</Link>
        </Button>
      </CardContent>
    </Card>
  </div>
)

export const ReportRoutes: React.FC = () => {
  const gates = useReportGates()

  return (
    <Routes>
      <Route index element={<ReportHub />} />
      {reports.map((report) => {
        const PageComponent = report.Component
        return (
          <Route
            key={report.slug}
            path={report.slug}
            element={
              gates[report.gate] ? (
                <ReportPageLayout
                  icon={report.icon}
                  iconColor={report.iconColor}
                  title={report.title}
                  description={report.description}
                >
                  <PageComponent />
                </ReportPageLayout>
              ) : (
                <ReportAccessDenied />
              )
            }
          />
        )
      })}
      <Route path="*" element={<Navigate to="/report" replace />} />
    </Routes>
  )
}
